/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateUpdateStageHintDto
 */
export interface CreateUpdateStageHintDto {
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateStageHintDto
     */
    stageDefinitionId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateStageHintDto
     */
    url: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateStageHintDto
     */
    descriptionPl: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateStageHintDto
     */
    descriptionEn: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateStageHintDto
     */
    deadline: CreateUpdateStageHintDtoDeadlineEnum;
    /**
     * 
     * @type {number}
     * @memberof CreateUpdateStageHintDto
     */
    order: number;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateStageHintDto
     */
    active: boolean;
}


/**
 * @export
 */
export const CreateUpdateStageHintDtoDeadlineEnum = {
    SinceProjectCreation: 'SinceProjectCreation',
    LastMonthEnd: 'LastMonthEnd',
    FifteenthOfCurrentMonth: 'FifteenthOfCurrentMonth',
    CurrentMonthEnd: 'CurrentMonthEnd',
    FifteenthOfNextMonth: 'FifteenthOfNextMonth',
    NextMonthEnd: 'NextMonthEnd'
} as const;
export type CreateUpdateStageHintDtoDeadlineEnum = typeof CreateUpdateStageHintDtoDeadlineEnum[keyof typeof CreateUpdateStageHintDtoDeadlineEnum];


/**
 * Check if a given object implements the CreateUpdateStageHintDto interface.
 */
export function instanceOfCreateUpdateStageHintDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "stageDefinitionId" in value;
    isInstance = isInstance && "url" in value;
    isInstance = isInstance && "descriptionPl" in value;
    isInstance = isInstance && "descriptionEn" in value;
    isInstance = isInstance && "deadline" in value;
    isInstance = isInstance && "order" in value;
    isInstance = isInstance && "active" in value;

    return isInstance;
}

export function CreateUpdateStageHintDtoFromJSON(json: any): CreateUpdateStageHintDto {
    return CreateUpdateStageHintDtoFromJSONTyped(json, false);
}

export function CreateUpdateStageHintDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdateStageHintDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'stageDefinitionId': json['stageDefinitionId'],
        'url': json['url'],
        'descriptionPl': json['descriptionPl'],
        'descriptionEn': json['descriptionEn'],
        'deadline': json['deadline'],
        'order': json['order'],
        'active': json['active'],
    };
}

export function CreateUpdateStageHintDtoToJSON(value?: CreateUpdateStageHintDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'stageDefinitionId': value.stageDefinitionId,
        'url': value.url,
        'descriptionPl': value.descriptionPl,
        'descriptionEn': value.descriptionEn,
        'deadline': value.deadline,
        'order': value.order,
        'active': value.active,
    };
}

